import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1a1a1a] text-[#f5f2ed] py-16 px-6">
      <div className="max-w-[1600px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-['Playfair_Display'] mb-2">Hale Modular</h3>
            <p className="text-sm text-[#9c9590] tracking-widest uppercase mb-4">Built to Last</p>
            <p className="text-sm text-[#9c9590] leading-relaxed max-w-xs">
              A design & build practice for those who value permanence.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-sm tracking-widest uppercase mb-4 text-[#b8986e]">Navigate</h4>
            <nav className="flex flex-col gap-3">
              <Link to="/work" className="text-sm text-[#9c9590] hover:text-[#f5f2ed] transition-colors">
                Work
              </Link>
              <Link to="/process" className="text-sm text-[#9c9590] hover:text-[#f5f2ed] transition-colors">
                Process
              </Link>
              <Link to="/about" className="text-sm text-[#9c9590] hover:text-[#f5f2ed] transition-colors">
                About
              </Link>
              <Link to="/explore-ideas" className="text-sm text-[#9c9590] hover:text-[#f5f2ed] transition-colors">
                Explore Ideas
              </Link>
              <Link to="/contact" className="text-sm text-[#9c9590] hover:text-[#f5f2ed] transition-colors">
                Contact
              </Link>
            </nav>
          </div>

          {/* Locations & Social */}
          <div>
            <h4 className="text-sm tracking-widest uppercase mb-4 text-[#b8986e]">Connect</h4>
            <p className="text-sm text-[#9c9590] mb-6">Mumbai | Gujarat</p>
            <div className="flex gap-4">
              <a
                href="https://instagram.com/halemodular"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#9c9590] hover:text-[#b8986e] transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://linkedin.com/company/halemodular"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#9c9590] hover:text-[#b8986e] transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-[#9c9590]/20 pt-8">
          <p className="text-xs text-[#9c9590] text-center">
            © {new Date().getFullYear()} Hale Modular. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
